import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import IconAddNote from '../../assets/icons/add-note.svg'
import MaskAdded from '../../assets/icons/mask_added_top.png'
import useMoney from '../../hooks/useMoney'
import { getCurrentGroupOrder } from '../../selectors'
import {
    checkCanFastAdd,
    checkTimeCanAddFood,
    getFoodPriceShow,
} from '../../utils'
import { getFullFileUrl } from '../../utils/formatData'
import { clsx } from '../../utils/helper'

import ButtonRound from '../elements/button-round'
import FormatCurrency from '../elements/FormatCurrency'
import GroupAmount from '../elements/group-amount'

import disableMask from '../../assets/images/disable-mask.png';
import useFood from '../../hooks/useFood'

const FoodItemMobile = ({
    item,
    setFoodSelected,
    handleUpdateAmount,
    handleFastAddToCart,
    handleViewFoodInCart,
    setFoodEditNote,
    setMoreInfo
}) => {
    const groupOrder = useSelector(getCurrentGroupOrder)
    const { currentPrice, originPrice } = useMoney(getFoodPriceShow, item)
    const { beilageItems, beilageMapped, updateAble, exitsInCart } = item
    const validTime = checkTimeCanAddFood(item)
    const { isFoodSoldOut: isFoodDisabled } = useFood(item);
    const { t } = useTranslation()

    const [isExpanded, setIsExpanded] = useState(false)
    const [showToggle, setShowToggle] = useState(false)
    const descriptionRef = useRef(null)

    useEffect(() => {
        if (descriptionRef.current) {
            const hasOverflow = descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight;
            setShowToggle(hasOverflow);
        }
    }, [item.description]);

    const showBtnAddNote = exitsInCart && checkCanFastAdd(item)

    const handleViewMoreInfo = e => {
        e.stopPropagation()
        e.preventDefault()
        setMoreInfo(item.productInfo)
    }

    const toggleExpandDescription = e => {
        e.stopPropagation()
        setIsExpanded(!isExpanded)
    }

    const handleClickAdd = e => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        typeof handleFastAddToCart === 'function' && handleFastAddToCart(item)
    }

    const handleClickFood = () => {
        if (isFoodDisabled) {
            return;
        }

        return checkCanFastAdd(item)
            ? validTime && !isFoodDisabled && handleClickAdd()
            : setFoodSelected(item)
    }

    const getActionUI = () => {
        const { currentAmount } = item;

        if (!exitsInCart) {
            return (
                <ButtonRound
                    outline
                    onClick={handleClickFood}
                    className="fast-add"
                >
                    {t(isFoodDisabled ? 'foodMobile.soldOut' : 'foodMobile.btnAdd')}
                </ButtonRound>
            )
        }

        if (!checkCanFastAdd(item) && !updateAble) {
            return (
                <ButtonRound
                    outline
                    onClick={() => handleViewFoodInCart(item)}
                    className="fast-add"
                >
                    {t(
                        currentAmount < 2
                            ? 'foodMobile.lbDishCount1'
                            : 'foodMobile.lbDishCountn',
                        { count: currentAmount }
                    )}
                </ButtonRound>
            )
        }

        return (
            <GroupAmount
                handleDecrease={() =>
                    handleUpdateAmount(
                        -1,
                        item.indexInCart,
                        item.id,
                        groupOrder
                    )
                }
                handleIncrease={handleClickAdd}
                currentValue={currentAmount}
            />
        )
    }

    return (
        <div className={clsx('box-food', isFoodDisabled && 'food-out-stock')}>
            {exitsInCart && (
                <div onClick={handleClickFood} className="mask-added">
                    <img src={MaskAdded} width="80px" />
                </div>
            )}

            <div
                onClick={handleClickFood}
                className="box-food__info"
            >
                <div className="box-food__banner">
                    <div className="banner-img">
                        {item.imagePath && <img className="image" alt="" src={getFullFileUrl(item.imagePath)} />}
                        <img alt="disable-mask" className="disable-mask" src={disableMask} />
                    </div>
                </div>

                <div className="box-food__details">
                    <div className="details__name">
                        {item.name}
                        {item.productInfo && (
                            <span
                                onClick={handleViewMoreInfo}
                                className="label-3 ml-2 primary-color"
                            >
                                {t('foodMobile.btnMoreInfo')}
                            </span>
                        )}
                    </div>

                    <div
                        ref={descriptionRef}
                        className={clsx('details__description', isExpanded && 'expanded')}
                    >
                        {item.description}
                    </div>

                    {showToggle && (
                        <div
                            onClick={toggleExpandDescription}
                            className="btn-toggle-desc"
                        >
                            {isExpanded ? t('foodMobile.btnCollapse', 'Thu gọn') : t('foodMobile.btnSeeMore', 'Xem thêm')}
                        </div>
                    )}

                    {beilageMapped && (
                        <div className="beilage-added">
                            {beilageMapped.map((bei, index) => (
                                <div
                                    key={index}
                                    className="beilage-added__item"
                                >
                                    <i>{bei.name_food}</i>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="box-food__actions">
                <div className="d-flex">
                    {!item.subs && (
                        <div className="food__price">
                            <FormatCurrency
                                className="current"
                                amount={currentPrice}
                            />
                        </div>
                    )}
                    {showBtnAddNote && (
                        <ButtonRound
                            className="mr-auto btn-note ml-2"
                            secondary
                            onClick={() => setFoodEditNote(item.id)}
                        >
                            <img
                                width="18px"
                                src={IconAddNote}
                                className="mr-1"
                            />
                            {t('foodMobile.btnNote')}
                        </ButtonRound>
                    )}
                </div>
                <div className="d-flex y-center">
                    {!!beilageItems.length && !updateAble && (
                        <div className="box-food__custom-able">
                            <i className="fas fa-coffee mr-2" />
                            {t('foodMobile.lbOptional')}
                        </div>
                    )}
                    {getActionUI()}
                </div>
            </div>
            {!!originPrice && (
                <FormatCurrency className="box-food__origin-price" tag="div" amount={originPrice} />
            )}
        </div>
    )
}

export default FoodItemMobile